export const MS_PER_SECOND = 1000
export const SECONDS_PER_MINUTE = 60

export const TEN_MINUTES_MS = 10 * SECONDS_PER_MINUTE * 1000
export const FIVE_SECONDS_MS = 5 * MS_PER_SECOND
